import { Box, Checkbox, FormControl, FormControlLabel, FormHelperText, Link } from '@mui/material';
import { ELinks, EMixpanelEvent } from '../../util/constants';
import GlobalContext from '../../contexts/GlobalContext';
import { FC, useContext } from 'react';
import mixpanel from 'mixpanel-browser';

type TLegalAgreementsCheckboxesProps = {
    tosAgreed: boolean;
    setTosAgreed: (tosAgreed: boolean) => void;
    tosIsValid?: boolean;
    marketingOptIn: boolean;
    setMarketingOptIn: (marketingOptIn: boolean) => void;
};

const LegalAgreementsCheckboxes: FC<TLegalAgreementsCheckboxesProps> = ({
    tosAgreed,
    setTosAgreed,
    marketingOptIn,
    setMarketingOptIn,
    tosIsValid = true,
}) => {
    const { language } = useContext(GlobalContext);

    const handleMarketingClick = () => {
        setMarketingOptIn(!marketingOptIn);
    };

    const handleTermsClick = () => {
        mixpanel.track(EMixpanelEvent.interacted, { key: 'consumer_create_account_terms' });
        setTosAgreed(!tosAgreed);
    };

    const tosLabel = () => {
        return (
            <Box component={'span'}>
                {language.legal.createAccountAgreementCheckbox}{' '}
                <Link
                    variant="subtitle2"
                    href={ELinks.privacyPolicy}
                    target="_blank"
                    onClick={() => {
                        mixpanel.track(EMixpanelEvent.interacted, { key: 'consumer_create_account_privacy' });
                    }}
                >
                    {language.legal.privacyPolicy}
                </Link>{' '}
                {language.common.and}
                {'\n'}
                <Link
                    variant="subtitle2"
                    href={ELinks.termsServiceConsumer}
                    target="_blank"
                    onClick={() => {
                        mixpanel.track(EMixpanelEvent.interacted, { key: 'consumer_create_account_terms' });
                    }}
                >
                    {language.legal.termsUse}
                </Link>
            </Box>
        );
    };

    return (
        <Box>
            <FormControlLabel
                slotProps={{ typography: { variant: 'body2' } }}
                control={
                    <Checkbox checked={marketingOptIn} onChange={handleMarketingClick} data-testid="marketingOptIn" />
                }
                label={language.marketing.marketingOptIn}
                sx={{ mb: 1 }}
            />
            <FormControl error={!tosIsValid}>
                <FormControlLabel
                    slotProps={{ typography: { variant: 'body2' } }}
                    control={
                        <Checkbox
                            checked={tosAgreed}
                            onChange={handleTermsClick}
                            data-testid="tosAgreement"
                            id="tosAgreement"
                        />
                    }
                    label={tosLabel()}
                />
                {!tosIsValid && <FormHelperText>{language.validation.legal}</FormHelperText>}
            </FormControl>
        </Box>
    );
};

export default LegalAgreementsCheckboxes;
